const rollBackToBatch = (items) =>
  items.reduce(
    (acc, { elementId, attribute, value }) => ({
      ...acc,
      [elementId]: {
        ...acc[elementId],
        [attribute]: value,
      },
    }),
    {}
  );

const unrollBatch = (batch) =>
  Object.entries(batch).flatMap(([elementId, attributes]) =>
    Object.entries(attributes).map(([attribute, value]) => ({
      elementId,
      attribute,
      value,
    }))
  );

const defaultFilterCallback = () => true;
const defaultComputeValueCallback = ({ value }) => value;

const modifyBatchChanges = ({
  batch,
  onFilterCallback = defaultFilterCallback,
  onComputeValueCallback = defaultComputeValueCallback,
}) => {
  const unrolledBatch = unrollBatch(batch);
  const modifiedBatch = unrolledBatch.filter(onFilterCallback).map((item) => ({
    ...item,
    value: onComputeValueCallback(item),
  }));

  return rollBackToBatch(modifiedBatch);
};

export default modifyBatchChanges;
